'use client';

import { cn } from '@/lib/utils';
import { forwardRef } from 'react';
import { useGlossaryDictionary } from '../_component/DictionaryProvider';

const AlphabeticHeader = forwardRef(function ({ letters = [], instruction, isLatinOnly }, ref) {
  const { filteredGroups } = useGlossaryDictionary();
  return (
    <div
      ref={ref}
      className={cn('pt-16 md:pt-20 pb-10 text-center mb-8', {
        'sticky top-[calc(var(--header-max-height)-40px)] bg-white border-b border-zinc-100': isLatinOnly
      })}
    >
      {isLatinOnly && (
        <h2 className='flex justify-center gap-x-3 md:gap-x-5 text-2xl xl:text-4xl font-semibold flex-wrap'>
          {letters.map(letter => {
            const isDisabled = !filteredGroups.some(([key]) => key === letter.toLowerCase());
            return (
              <a
                href={isDisabled ? '' : `#${letter.toLowerCase()}`}
                className={cn({
                  'text-gray-400 pointer-events-none': isDisabled
                })}
                key={letter}
              >
                {letter}
              </a>
            );
          })}
        </h2>
      )}
      {instruction && (
        <p
          className={cn('mt-6', {
            'h3 leading-normal': !isLatinOnly
          })}
        >
          {instruction}
        </p>
      )}
    </div>
  );
});
AlphabeticHeader.displayName = 'AlphabeticHeader';

export default AlphabeticHeader;
